import store from '@/store'
import configs from '@/plugins/configs'

let tokenRefreshIntervalId = null

export function startTokenRefresh (keycloak, idletime, tokenexpiry) {
  if (tokenRefreshIntervalId) clearInterval(tokenRefreshIntervalId)

  tokenRefreshIntervalId = setInterval(() => {
    keycloak.updateToken(idletime)
      .then(refreshed => {
        if (refreshed) {
          store.commit('auth/UPDATE_TOKEN', keycloak.token)
        }
      })
      .catch(() => {
        console.error('Failed to refresh token')
        stopTokenRefresh()
        setTimeout(() => {
          var idtoken = localStorage.getItem('kc_idtoken')
          const logoutUrl = `${configs.keycloakurl}/realms/${configs.keycloakrealm}/protocol/openid-connect/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + process.env.BASE_URL + 'login')}&client_id=${configs.keycloakclientId}&id_token_hint=${idtoken}`
          window.location.href = logoutUrl
          localStorage.clear()
          sessionStorage.clear()
        }, 100)
        store.dispatch('auth/logout')
      })
  }, tokenexpiry * 1000 * 0.75)
}

export function stopTokenRefresh () {
  if (tokenRefreshIntervalId) {
    clearInterval(tokenRefreshIntervalId)
    tokenRefreshIntervalId = null
  }
}

// export function refreshTokenNow (keycloak, idletime, tokenexpiry) {
//   if (tokenRefreshIntervalId) clearInterval(tokenRefreshIntervalId)

//   tokenRefreshIntervalId = setInterval(() => {
//     return keycloak.updateToken(idletime)
//       .then(refreshed => {
//         if (refreshed) {
//           store.commit('auth/UPDATE_TOKEN', keycloak.token)
//           console.log('Token refreshed on demand')
//           return true
//         } else {
//           console.log('Token was still valid')
//           return false
//         }
//       })
//       .catch(() => {
//         stopTokenRefresh()
//         console.error('Failed to refresh token')
//         return false
//       })
//   }, tokenexpiry * 1000 * 0.75)
// }

export function refreshTokenNow (keycloak, minValidity = 30) {
  if (!keycloak?.refreshToken) {
    console.warn('No refresh token — session likely expired')
    return Promise.resolve(false)
  }

  return keycloak.updateToken(minValidity)
    .then(refreshed => {
      if (refreshed) {
        store.commit('auth/UPDATE_TOKEN', keycloak.token)
        console.log('Token refreshed on demand')
        return true
      } else {
        console.log('Token was still valid')
        return true
      }
    })
    .catch(err => {
      console.error('Failed to refresh token', err)
      return false
    })
}
